import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SettingsService } from '../setting-service/setting.service';

@Injectable({
    providedIn: 'root'
})

export class GuardService {


    constructor(
        private settingsService: SettingsService,
        private router: Router
    ) { }

    async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        // DEFINE URL DE RETORNO
        if (state.url !== '/refresh') {
            this.settingsService.urlretorno = state.url;
        }
        // VERIFICA SE ESTA AUTENTICADO.
        if (this.settingsService.logado != true) {

            return this.router.navigate(['/login']);

        } else {

            return true;

        }

    }

}
